<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('c2c.xq')}}</div>
        </div>
        <div class="cont-box">
            <div class="cont" v-html="content"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'bannerDetail',
    data () {
        return {
           id: '',
          content: ''
        }
    },
    created(){
      this.id = this.$route.query.id;
    },
    mounted(){
        this.getBanner();
    },
    methods: {
        getBanner(){
          let params = {
            id: this.id,
            token: 1
          }
          this.$ajax.get('/web/getBanner',{params}).then((res) => {
            let resData = res.data.data[0];
            this.content = this.contHtml(resData.content);
          }).catch(function(err){
              console.log(err)
          })
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        goBack(){
            this.$router.push('/index');
        }
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .center{
        text-align: center;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }

    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .3rem;
        /* background: #040A26; */
        box-sizing: border-box;
        overflow-y: auto;
    }
    .cont{
        padding: .4rem 0;
        color: #acacac!important;
        font-size: .48rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bannerDetail.vue